/* eslint-disable no-unused-vars */
import styled, { keyframes } from 'styled-components';
import { Palette } from 'config';

const shine = keyframes`
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
`;

export const Box = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
  position: absolute;
  top: 0;
  left: 0;
  background-color: #060429;
  overflow: hidden;
`;

export const LoaderBox = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  z-index: 99999;
`;

export const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 440px;
  margin: 0 16px;
  position: relative;
  z-index: 10;

  /* Glassmorphism */
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(24px);
  -webkit-backdrop-filter: blur(24px);
  padding: 32px;
  @media (min-width: 768px) {
    padding: 40px;
  }
  border-radius: 24px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  box-sizing: border-box;

  /* Form Glow Effect */
  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(to right, rgba(53, 153, 231, 0.2), rgba(46, 185, 167, 0.2));
    border-radius: 24px;
    filter: blur(40px);
    z-index: -1;
  }
`;

export const Title = styled.h1`
  font-size: 40px;
  font-weight: 700;
  line-height: 48px;
  font-family: 'Lato', system-ui, sans-serif;
  background: linear-gradient(135deg, #a4cbef 0%, #5397e1 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  padding-bottom: 4px;
  margin: 0 0 16px 0;
`;

export const Paragraph = styled.p`
  font-size: 14px;
  line-height: 20px;
  color: #a0aec0;
  margin-bottom: 24px;
  font-family: 'Lato', system-ui, sans-serif;
`;

export const BtnBox = styled.div`
  margin-top: 24px;
  display: flex;
  gap: 16px;
  width: 100%;
`;

export const CancelButton = styled.button`
  flex: 1;
  height: 48px;
  background: transparent;
  border: 2px solid rgba(255, 255, 255, 0.2);
  color: #3599e7;
  border-radius: 12px;
  font-weight: 600;
  font-family: 'Lato', system-ui, sans-serif;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: rgba(255, 255, 255, 0.35);
  }
`;

export const SendButton = styled.button`
  flex: 1;
  height: 48px;
  background: linear-gradient(to right, #3599e7, #9accf3);
  color: white;
  border: none;
  border-radius: 12px;
  font-weight: 600;
  font-family: 'Lato', system-ui, sans-serif;
  cursor: pointer;
  box-shadow: 0 10px 15px -3px rgba(53, 153, 231, 0.3);
  transition: all 0.2s ease;
  overflow: hidden;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(to right, rgba(255, 255, 255, 0.3), transparent);
    animation: ${shine} 2.5s linear infinite;
    pointer-events: none;
  }

  &:hover:not(:disabled) {
    transform: scale(1.02);
  }

  &:active:not(:disabled) {
    transform: scale(0.98);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
  width: 100%;
`;

export const InputLabel = styled.label`
  font-size: 14px;
  color: #a0aec0;
  margin-bottom: 8px;
  font-family: 'Lato', system-ui, sans-serif;
  font-weight: 500;
`;

export const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  background: rgba(255, 255, 255, 0.05);
  border: 2px solid ${(props) => (props.error ? '#ff4d4f' : 'rgba(255, 255, 255, 0.2)')};
  border-radius: 12px;
  padding: 0 16px;
  height: 48px;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  box-sizing: border-box;

  &:focus-within {
    border-color: ${(props) => (props.error ? '#ff4d4f' : '#3599e7')};
    transform: translateY(-2px);
    box-shadow: 0 4px 20px rgba(53, 153, 231, 0.15);
  }
`;

export const StyledInput = styled.input`
  flex: 1;
  background: transparent;
  border: none;
  outline: none;
  color: #fff;
  font-size: 15px;
  font-family: 'Lato', system-ui, sans-serif;
  height: 100%;
  width: 100%;
  box-sizing: border-box;

  &::placeholder {
    color: rgba(255, 255, 255, 0.3);
  }

  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    -webkit-text-fill-color: #fff !important;
    -webkit-box-shadow: 0 0 0px 1000px transparent inset !important;
    transition: background-color 5000s ease-in-out 0s;
  }
`;

export const ErrorText = styled.span`
  color: #ff4d4f;
  font-size: 12px;
  margin-top: 4px;
  font-family: 'Lato', system-ui, sans-serif;
`;

export const SubmitSuccessfulBox = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 440px;
  margin: 0 16px;
  position: relative;
  z-index: 10;

  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(24px);
  -webkit-backdrop-filter: blur(24px);
  padding: 32px;
  @media (min-width: 768px) {
    padding: 40px;
  }
  border-radius: 24px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  box-sizing: border-box;
  text-align: center;
`;

export const SuccessText = styled.p`
  color: #a0aec0;
  font-size: 14px;
  line-height: 20px;
  margin-top: 16px;
  font-family: 'Lato', system-ui, sans-serif;
`;

export const SuccessLink = styled.span`
  color: #3599e7;
  font-weight: 700;
  cursor: pointer;
  font-family: 'Lato', system-ui, sans-serif;
`;
